"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
const Item = _ref => {
  let {
    children,
    className,
    href = '#',
    isPreview,
    onClick,
    type,
    imageDisclaimer
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Gallery-Item', `cds-Gallery-Item--${(0, _upperCase.upperCaseFirst)(type)}`, {
    'cds-Gallery-Item--Preview': isPreview,
    'swiper-no-swiping': type === 'image360' && !isPreview
  }, className);
  if (!onClick) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, children, imageDisclaimer && /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-Gallery-Item-Disclaimer"
    }, imageDisclaimer));
  }
  return /*#__PURE__*/_react.default.createElement("a", {
    className: rootClassName,
    href: href,
    onClick: onClick
  }, children, imageDisclaimer && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Gallery-Item-Disclaimer"
  }, imageDisclaimer));
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map